import styled from '@emotion/styled';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface SectionCardProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

const CardStyled = styled(Card)`
  overflow: visible;
`;

const Content = styled(CardContent)`
  min-width: 0;
  padding: ${({ theme }) => theme.spacing(2.5)};

  &:last-child {
    padding-bottom: ${({ theme }) => theme.spacing(2.5)};
  }
`;

const Header = styled(Box)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
`;

const Title = styled(Box)`
  min-width: 0;
`;

const SectionCard = ({ title, subtitle, actions, children }: SectionCardProps) => (
  <CardStyled>
    <Content>
      {(title || subtitle || actions) && (
        <>
          <Header>
            <Title>
              {title && <Typography variant="subtitle1">{title}</Typography>}
              {subtitle && (
                <Typography variant="body2" color="text.secondary">
                  {subtitle}
                </Typography>
              )}
            </Title>
            {actions}
          </Header>
          <Divider sx={{ mb: 2 }} />
        </>
      )}
      {children}
    </Content>
  </CardStyled>
);

export default SectionCard;
